import Vue from 'vue';
import firebase from 'firebase/app';
// import axios from 'axios';
import 'firebase/auth';
import 'firebase/database';

const firebaseApp = firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL
});
// firebase.database.INTERNAL.forceLongPolling();

// Vue.prototype.$ajax = axios;

Vue.prototype.$fd = firebase.database;

Vue.prototype.$fb = firebaseApp;

Vue.prototype.$auth = firebase.auth();

Vue.prototype.$db = firebase.database();

export default firebaseApp;
